module.exports = __webpack_public_path__ + "static/img/7.68df770.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mOfficial/7.png
// module id = GGt9
// module chunks = 1